export type TipoDePieza = 'billete' | 'moneda';

export interface Pieza {

  readonly clave: string;
  readonly valor: number;
  readonly etiqueta: string;
  readonly tipo: TipoDePieza;
}

function pieza(tipo: TipoDePieza, valor: number, etiqueta: string): Pieza {
  return { clave: `${tipo}-${valor}`, valor, etiqueta, tipo };
}

export const BILLETES: readonly Pieza[] = [
  pieza('billete', 100, '$100'),
  pieza('billete', 50, '$50'),
  pieza('billete', 20, '$20'),
  pieza('billete', 10, '$10'),
  pieza('billete', 5, '$5'),
  pieza('billete', 1, '$1'),
];

export const MONEDAS: readonly Pieza[] = [
  pieza('moneda', 1, '$1'),
  pieza('moneda', 0.5, '50¢'),
  pieza('moneda', 0.25, '25¢'),
  pieza('moneda', 0.1, '10¢'),
  pieza('moneda', 0.05, '5¢'),
  pieza('moneda', 0.01, '1¢'),
];

export const PIEZAS: readonly Pieza[] = [...BILLETES, ...MONEDAS];

export type Conteo = Record<string, string>;

export function cuantas(conteo: Conteo, pieza: Pieza): number {
  const piezas = Number(conteo[pieza.clave] ?? 0);
  return Number.isFinite(piezas) && piezas > 0 ? piezas : 0;
}

export function importeDe(conteo: Conteo, pieza: Pieza): number {
  return enCentimos(cuantas(conteo, pieza) * pieza.valor);
}

export function subtotalDe(conteo: Conteo, piezas: readonly Pieza[]): number {
  return enCentimos(piezas.reduce((suma, p) => suma + cuantas(conteo, p) * p.valor, 0));
}

export function totalContado(conteo: Conteo): number {
  return subtotalDe(conteo, PIEZAS);
}

export function loContado(conteo: Conteo) {
  return PIEZAS.filter((p) => cuantas(conteo, p) > 0).map((p) => ({
    valor: p.valor,
    cantidad: cuantas(conteo, p),
    tipo: p.tipo,
  }));
}

function enCentimos(importe: number): number {
  return Math.round(importe * 100) / 100;
}
